import { useContext } from 'react';
import useKuntoarviovalikkoV2 from './services/useKuntoarviovalikkoV2';
import KuntoarviovalikkoView from './views/KuntoarviovalikkoView';
import { ReportTemplateContext } from '../../ReportTemplate/ReportTemplateContext';

// v2 of the "Kuntoarviovalikko" block. Same scope as v1's
// SubsectionBuilderBlock: picking a category provisions the backend
// hierarchy (dynamic_pts_project -> kuntoarviovalikko -> tarkastuskohde)
// AND clones the category's DB-authored template section into
// report_sections (server-side port of SubsectionBuilderBlock's
// useSectionTemplate path — see services/useKuntoarviovalikkoV2.js).
// The "DB-taulut" button opens /db-viewer/:ptsProjectId in a new tab —
// see pages/DbViewerPage.jsx — a read-only view of the live rows behind
// the currently chosen PTS project. Dev/debug tool, so it's only shown in
// edit mode, not to anyone just reading the report.
export default function KuntoarviovalikkoBlockV2({ data, onChange, card }) {
  const id_kiinteisto = card?.id_kiinteisto ?? null;
  const templateCtx = useContext(ReportTemplateContext);
  const svc = useKuntoarviovalikkoV2(id_kiinteisto, data, onChange, templateCtx?.report?.id, templateCtx?.fetchReportData, templateCtx?.report?.type, false, templateCtx?.sections);

  // Same tarkastuskohde/rakenneosa data is also managed from the
  // standalone taloyhtiökortti Kuntoarvio workspace (KuntoarvioWorkspaceV2,
  // /taloyhtiokortti/:id?tab=jarjestelmakuvaus&subtab=julkisivut) — only
  // meaningful for the v2 julkisivu report type this block was actually
  // built for, not the other report types that happen to embed it.
  const isJulkisivuV2Report = templateCtx?.report?.type === 'julkisivujen_kuntotutkimus_v2';
  const taloyhtiokorttiUrl = isJulkisivuV2Report && id_kiinteisto
    ? `/taloyhtiokortti/${id_kiinteisto}?tab=jarjestelmakuvaus&subtab=julkisivut${svc.ptsProjectId ? `&project=${svc.ptsProjectId}` : ''}`
    : null;

  // No own header row here — the generic report-section chrome
  // (ReportSectionRenderer.jsx) already shows this section's own name
  // ("Kuntoarviovalikko (v2)") right above; a second "Kuntoarviovalikko"
  // heading here just repeated it. The taloyhtiökortti link + DB-taulut
  // are handed to the view instead, where they sit at the end of the
  // "Linkitetty PTS-projekti" row — real context (which project), not a
  // disconnected header row.
  return (
    <div style={{ border: '1px solid #dee2e6', borderRadius: 8, padding: 16, background: '#fff' }}>
      <KuntoarviovalikkoView id_kiinteisto={id_kiinteisto} svc={svc} taulukkoUrl={taloyhtiokorttiUrl} editMode={!!templateCtx?.editMode} />
    </div>
  );
}
